import { Formattable } from 'visuris/Data/Entities/Formattable';
import { formatDate } from 'visuris/Data/Formatters';
import * as i18n from 'CMS/core/i18n';

export default class ShipClaim extends Formattable {

    public id: string = null;
    public actualFlaRefID: number = null;
    public webuserID: string = null;
    public webuserFirstName: string = null;
    public webuserLastName: string = null;
    public weborganisationName: string = null;
    public webuserEmail: string = null;
    public webuserMobilePhonePrimary: string = null;
    public webuserMobilePhoneSecondary: string = null;
    public webuserEmailConfirmed: boolean = null;
    public webuserMobilePhonePrimaryConfirmed: boolean = null;
    public webuserMobilePhoneSecondaryConfirmed: boolean = null;
    public weborganisationEmail: string = null;
    public weborganisationMobilePhonePrimary: string = null;
    public weborganisationMobilePhoneSecondary: string = null;
    public weborganisationEmailConfirmed: boolean = null;
    public weborganisationMobilePhonePrimaryConfirmed: boolean = null;
    public weborganisationMobilePhoneSecondaryConfirmed: boolean = null;
    public idType: string = null;
    public idNumber: string = null;
    public immatriculationNumber: string = null;
    public mmsi: string = null;
    public imo: string = null;
    public ofs: string = null;
    public ern: string = null;
    public eni: string = null;
    public hin: string = null;
    public cin: string = null;
    public shipName: string = null;
    public status: number = null;
    public statusReason: string = null;
    public linkOrganisationShipID: string = null;
    public originalFlaRefID: number = null;
    public length: number = null;
    public width: number = null;
    public speedOverGround: number = null;
    public commercial: boolean = null;
    public passengersAllowed: boolean = null;
    public verificationMethod: number = null;
    public emailOverrule: string = null;
    public mobilePhoneOverrule: string = null;
    public weborganisationID: string = null;
    public remark: string = null;
    public archivedBySender: boolean = null;
    public archivedByAdmin: boolean = null;
    public shipRegistrationRequired: boolean = null;
    public emailOverruleConfirmed: boolean = null;
    public mobilePhoneOverruleConfirmed: boolean = null;
    public createdAt: Date = null;
    public modifiedAt: Date = null;
    public statusMessage: string = null;
    public verificationMethodMessage: string = null;
    public registrationCountry: string = null;
    public registrationCountryMessage: string = null;
    public tonnageCertificates: any[] = null;

    constructor() {
        super();
    }

    protected getFormatters(): any {
        return {
            "createdAt": () => { return formatDate(this.createdAt); },
            "modifiedAt": () => { return formatDate(this.modifiedAt); },
            "boatingTypeMessage": () => { return this.commercial ? i18n.getMessage('shipClaim.commercial') : i18n.getMessage('shipClaim.pleasure'); },
            "passengersAllowedMessage": () => { return this.passengersAllowed ? i18n.getMessage('general.yes') : i18n.getMessage('general.no'); },
            "idType": () => { return this.idType; },
            "idNumber": () => { return this.idNumber; },
            "registrationCountryMessage": () => { return this.registrationCountryMessage; },
            "dimensions": () => { return (this.length == null ? '-' : this.length + ' ' + i18n.getMessage('units.meters')) + ' x ' + (this.width == null ? '-' : this.width + ' ' + i18n.getMessage('units.meters')); }
        };
    }

    public canCancel(): boolean {
        return this.status != null && (this.status === 0 || this.status === 5 || this.status === 6 || this.status === 7 || this.status === 8);
    }
    public canCompleteRegistration(): boolean {
        return this.status != null && (this.status === 6);
    }
    public canConfirmTakeOver(): boolean {
        return this.status != null && (this.status === 7);
    }
    public canConfirmContactDataUpdate(): boolean {
        return this.status != null && (this.status === 8);
    }
    public canApprove(): boolean {
        return this.status != null && (this.status === 0 || this.status === 5 || this.status === 8);
    }
    public canAbort(): boolean {
        return this.status != null && (this.status === 0 || this.status === 5 || this.status === 6 || this.status === 7 || this.status === 8);
    }
    public canRequestContactDataUpdate(): boolean {
        return this.status != null && (this.status === 2);
    }
    public canRestart(): boolean {
        return this.status != null && (this.status === 2 || this.status === 4);
    }
    public canArchive(): boolean {
        return this.status != null && (this.status === 1 || this.status === 2 || this.status === 3 || this.status === 4);
    }

}